import { render, staticRenderFns } from "./Parteners.vue?vue&type=template&id=5df05f5e&"
import script from "./Parteners.vue?vue&type=script&lang=js&"
export * from "./Parteners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports